import { useNavigate } from "react-router-dom";
import ScrollablePageWrapper from "~/components/shared/page-wrapper";
import { Icon } from "~/components/ui";
import PTWForm from "./form";

const CreatePTWPage = () => {
  const navigate = useNavigate();

  return (
    <div>
      <div className="hidden h-screen w-full sm:block">
        <ScrollablePageWrapper>
          <div className="space-y-8 pr-32">
            <div className="flex items-center justify-between">
              {/* Head */}
              <div className="flex items-center gap-4">
                <Icon
                  name="ArrowLeft"
                  className="h-5 w-5 text-neutral-900 hover:cursor-pointer"
                  onClick={() => navigate(-1)}
                />
                <h1 className="font-Medium text-2xl text-primary-500">
                  Create Permit To Work (PTW)
                </h1>
              </div>
            </div>

            <PTWForm />
          </div>
        </ScrollablePageWrapper>
      </div>
    </div>
  );
};

export default CreatePTWPage;
